<template>
  <div class="recipient-option">
    <h3 v-if="salesForceRecipients.length" class="page-header">
      Select Salesforce recipient
    </h3>
    <label
      class="radio"
      v-for="salesforce in filteredRecipientsBySalesForce"
      :key="salesforce.salesForceUI"
    >
      <input
        :id="salesforce.salesForceUI"
        type="radio"
        :name="salesforce.recipientName"
        :value="salesforce.salesForceUI"
        v-model="order.selectedRecipientId"
        @change="
          setRecipient(salesforce.salesForceUI, 'salesForceUID', salesforce)
        "
      />
      <span>{{
        salesforce.address
          ? `${salesforce.recipientName} ${salesforce.address}`
          : salesforce.email
      }}</span>
    </label>

    <h3 class="page-header">Select a recipient</h3>
    <label
      class="radio"
      v-for="recipient in filteredRecipients"
      :key="recipient.id"
      :for="recipient.id"
    >
      <input
        :id="recipient.id"
        type="radio"
        :name="recipient.name"
        :value="recipient.id"
        v-model="order.selectedRecipientId"
        @change="setRecipient(recipient.id, 'gemnoteUID')"
      />
      <span>{{ recipient.attributes.name }}</span>
    </label>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    recipients: {
      type: Array
    }
  },
  data() {
    return {
      get salesForceRecipients() {
        let recipientInfo = JSON.parse(localStorage.getItem('recipientInfo'))
        return !recipientInfo ? [] : recipientInfo
      },
      existingRecipients: []
    }
  },
  computed: {
    filteredRecipients() {
      return this.recipients.filter(
        recipient => recipient.attributes.name !== null
      )
    },
    filteredRecipientsBySalesForce() {
      let filtered = this.salesForceRecipients
      for (let i = 0; i < this.salesForceRecipients.length; i++) {
        let uid = this.salesForceRecipients[i].salesForceUI
        let alreadyExist = this.recipients.filter(
          recipient => recipient.attributes.salesforceResourceUid === uid
        )
        if (alreadyExist.length !== 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.existingRecipients.push(alreadyExist[0])
          filtered = filtered.filter(
            rmRecipient => rmRecipient.salesForceUI !== uid
          )
        }
      }
      return filtered
    },
    ...mapState(['order'])
  },
  methods: {
    setRecipient(recipientId, recipientResourceType, salesForceRecipient = {}) {
      this.$store.dispatch('order/setSelectdRecipient', {
        recipientId,
        recipientResourceType,
        salesForceRecipient
      })

      if (recipientResourceType === 'gemnoteUID') {
        let found = this.existingRecipients.find(
          salesRecipient => salesRecipient.id == recipientId
        )

        if (found) {
          let salesforceItem = this.salesForceRecipients.find(
            salesForceItem =>
              salesForceItem.salesForceUI ===
              found.attributes.salesforceResourceUid
          )

          let addressOne = salesforceItem.address.split('\n')
          addressOne = addressOne[0]
          this.$store.dispatch('recipient/updateRecipient', {
            recipientId,
            addressOne
          })
        }
      }
    }
  }
}
</script>

<style scoped>
.recipient-option {
  padding-bottom: 1rem;
}

h3 {
  text-align: left;
}

h5 {
  text-align: left;
}
</style>
